import { useContext } from 'react'
import axios from 'axios'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { GoogleLogin } from '@react-oauth/google'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'react-simple-snackbar'

import { UserContext } from '../contexts/UserContext'
import { SERVER_URL, SNACKBAR_STYLE } from '../constants'

function AuthButton() {
  const { setUser } = useContext(UserContext)
  const navigate = useNavigate()
  const [openSnackbar] = useSnackbar(SNACKBAR_STYLE)

  function handleRequest(credentialResponse) {
    const token = credentialResponse.credential

    axios
      .post(`${SERVER_URL}/auth`, '', {
        headers: {
          token: token,
        },
      })
      .then((res) => {
        openSnackbar(<>Preparing register&#8230;</>)
        setTimeout(() => {
          openSnackbar(<>Ready&#8230; Signed in as {res.data.employee_name}</>)
          setUser(res.data)
          navigate('/all')
        }, 1200)
      })
  }

  function handleError() {
    console.error('Error authenticating')
  }

  return (
    <GoogleOAuthProvider clientId="502609023665-uqcjour1r4gc2or2h3dc3cotfqo5jkk2.apps.googleusercontent.com">
      <GoogleLogin onSuccess={handleRequest} onError={handleError} />
    </GoogleOAuthProvider>
  )
}

export default AuthButton
